import { AfterViewInit, Component, DestroyRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgTemplateOutlet } from '@angular/common';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { debounceTime, finalize } from 'rxjs/operators';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DocumentFieldChange, FilterConfig, ListFilter } from '@parashift/shared/models';
import { DocumentFieldChangeService, ErrorResponse, JsonApiQueryData, ListFilterService, Logger } from '@parashift/shared/services';
import { PdcDatePipe, PageNumberPipe, StringifyPipe } from '@parashift/shared/pipes';
import { FilterColumnComponent, FilterSortingComponent, FilterTagsComponent, LeftColumnComponent, ListPaginationComponent, ValueDiffComponent } from '@parashift/shared/components';

@Component({
  selector: 'pdc-field-errors-list',
  templateUrl: './field-errors-list.component.html',
  styleUrls: ['./field-errors-list.component.scss'],
  imports: [
    FaIconComponent,
    FilterColumnComponent,
    FilterSortingComponent,
    FilterTagsComponent,
    LeftColumnComponent,
    ListPaginationComponent,
    NgTemplateOutlet,
    PageNumberPipe,
    PdcDatePipe,
    StringifyPipe,
    TooltipModule,
    ValueDiffComponent
]
})
export class FieldErrorsListComponent implements OnInit, AfterViewInit {
  private route = inject(ActivatedRoute);
  private documentFieldChangeService = inject(DocumentFieldChangeService);
  private listFilterService = inject(ListFilterService);
  private logger = inject(Logger);
  private destroyRef = inject<DestroyRef>(DestroyRef);

  @ViewChild(FilterColumnComponent) filterComponent: FilterColumnComponent;
  @Input() filterColumnConfig: FilterConfig;

  tenant_id: number;
  documentFieldChanges: JsonApiQueryData<DocumentFieldChange>;
  listFilter: ListFilter;
  loading = true;

  ngOnInit() {
    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params: ParamMap) => {
      this.tenant_id = params.get('tenant_id') ? Number(params.get('tenant_id')) : undefined;
      this.initListFilter();
      this.getDocumentFieldChanges();
    });
  }

  ngAfterViewInit() {
    this.filterComponent.$filterParams
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        debounceTime(400)
      )
      .subscribe(listFilter => {
        this.listFilter = listFilter as ListFilter;
        this.getDocumentFieldChanges();
      });
  }

  initListFilter() {
    this.listFilter = this.listFilterService.getStoredFilters(
      this.filterColumnConfig.meta.identifier,
      {
        stats: { total: ['count'] },
        include: 'document_type,' +
                 'document_type_field,' +
                 'document_task,' +
                 'document_section,' +
                 'document_section.document_type_section',
        filter: {
          workflow_task: 'extraction-qc'
        }
      },
      true
    );
  }

  private getDocumentFieldChanges() {
    this.loading = true;
    this.documentFieldChangeService.findAll(this.listFilter, this.tenant_id)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: documentFieldChanges => {
          this.documentFieldChanges = documentFieldChanges;
        },
        error: (error: ErrorResponse) => {
          this.logger.log('field-errors-list-component', 'FIELD ERRORS LIST Error', error);
        }
      });
  }
}
